import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Logo from "../../assets/logotipo-ifeira.svg";
import LoginProvider from "../../providers/LoginProvider";
import { login } from "../../services/Auth";

import "./styles.css";

class Login extends Component {
  state = {
    email: "",
    password: "",
    error: "",
    ativo: false,
    emailSelected: false,
    passwordSelected: false
  };

  handleLogin = async e => {
    e.preventDefault();
    const { email, password } = this.state;
    if (!email || !password) {
      this.setState({ error: "Preencha e-mail e senha para continuar!" });
    } else {
      try {
        const LProvider = new LoginProvider();
        const response = await LProvider.login(email, password);
        await login(response.data.token, response.data.usuario);
        this.props.history.push("/app/principal");
      } catch (err) {
        this.setState({
          error: "Houve um problema com o login, verifique suas credenciais"
        });
      }
    }
  };

  render() {
    return (
      <div className={"container-flex"}>
        <form className={"form"} onSubmit={this.handleLogin}>
          <img
            src={Logo}
            alt="iFeira logo"
            style={{ margin: 0, marginTop: 50 }}
          />
          <br></br>
          <h2
            style={{
              color: "#717A8C",
              marginBottom: 50,
              marginTop: 30,
              fontSize: 16,
              fontWeight: "bold"
            }}
          >
            MÓDULO DO ESTABELECIMENTO
          </h2>
          {this.state.error && (
            <p style={{ paddingLeft: 35, color: "red" }}>{this.state.error}</p>
          )}
          {this.state.emailSelected ? (
            <p
              style={{
                color: "#701B8C",
                margin: 0,
                paddingLeft: 35,
                fontSize: 14,
                fontWeight: 900
              }}
            >
              Email
            </p>
          ) : null}
          <input
            onFocus={() => {
              this.setState({ emailSelected: true });
            }}
            onBlur={() => {
              this.setState({ emailSelected: false });
            }}
            type="email"
            placeholder={this.state.emailSelected ? "" : "Email"}
            onChange={e => this.setState({ email: e.target.value })}
          />

          {this.state.passwordSelected ? (
            <p
              style={{
                color: "#701B8C",
                margin: 0,
                paddingLeft: 35,
                fontSize: 14,
                fontWeight: 900
              }}
            >
              Senha
            </p>
          ) : null}
          <div>
            <input
              onFocus={() => {
                this.setState({ passwordSelected: true });
              }}
              onBlur={() => {
                this.setState({ passwordSelected: false });
              }}
              type="password"
              placeholder={this.state.passwordSelected ? "" : "Senha"}
              onChange={e => this.setState({ password: e.target.value })}
            />
            <p
              className={"senha-especificacao"}
              style={{ fontSize: 13, textAlign: "center" }}
            >
              São 8 caractéres com letras e números
            </p>
          </div>
          <div style={{ padding: 0, paddingLeft: 34, paddingRight: 34 }}>
            {this.state.email !== "" && this.state.password !== "" ? (
              <button type="submit" className="ativo">
                ENTRAR
              </button>
            ) : (
              <button type="submit">ENTRAR</button>
            )}
          </div>
          <p style={{ fontSize: 12, textAlign: "center" }}>
            Ao continuar, você concorda com os <span>Termos & Condições</span>
          </p>
        </form>
      </div>
    );
  }
}

export default withRouter(Login);
